import type { ModerationChoice } from '@/hooks/use-page-moderation';
import type { Photo } from '@/services/photovogue';
import { PhotoCard } from '@/components/photovogue/photo-card/component';
import { PhotoListItem } from '@/components/photovogue/photo-list-item/component';

export type PhotoView = 'grid' | 'list';

export interface PhotoGridProps {
  photos: Photo[];
  view: PhotoView;
  selectable: boolean;
  moderating?: boolean;
  disabled?: boolean;
  ignoredIds?: string[];
  onChoice?: (id: string, choice: ModerationChoice) => void;
  onPreview?: (photo: Photo) => void;
  selectedIds: string[];
  onToggleSelect: (id: string) => void;
  onOpen: (photo: Photo) => void;
}

export const PhotoGrid = ({
  photos,
  view,
  selectable,
  moderating = false,
  disabled = false,
  ignoredIds = [],
  onChoice,
  onPreview,
  selectedIds,
  onToggleSelect,
  onOpen,
}: PhotoGridProps) => {
  if (view === 'list') {
    return (
      <div className="flex flex-col gap-2">
        {photos.map((photo) => (
          <PhotoListItem
            key={photo.id}
            photo={photo}
            selectable={selectable}
            moderating={moderating}
            disabled={disabled}
            ignoredIds={ignoredIds}
            onChoice={onChoice}
            onPreview={onPreview}
            selected={selectedIds.includes(photo.id)}
            onToggleSelect={onToggleSelect}
            onOpen={onOpen}
          />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5">
      {photos.map((photo) => (
        <PhotoCard
          key={photo.id}
          photo={photo}
          selectable={selectable}
          moderating={moderating}
          disabled={disabled}
          ignoredIds={ignoredIds}
          onChoice={onChoice}
          onPreview={onPreview}
          selected={selectedIds.includes(photo.id)}
          onToggleSelect={onToggleSelect}
          onOpen={onOpen}
        />
      ))}
    </div>
  );
};

export default PhotoGrid;
